import createIcon from '../../createIcon';

/**
 * @component @name ArrowOutward
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi41IDUuNVY3LjVIMTUuMDlMNS41IDE3LjA5TDYuOTEgMTguNUwxNi41IDguOTFWMTcuNUgxOC41VjUuNUg2LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ArrowOutward = createIcon('ArrowOutward', [
  [
    'path',
    { d: 'M6.5 5.5V7.5H15.09L5.5 17.09L6.91 18.5L16.5 8.91V17.5H18.5V5.5H6.5Z', key: '16gj2f' },
  ],
]);

export default ArrowOutward;
